import React, { useEffect, useState } from "react";
import intl from "react-intl-universal";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { Line } from "src/components/base/Line";
import { RoomData } from "src/types/listing.type";
import { HomePageContentWrapper } from "../Shared";
import { fetchListings } from "src/redux/modules/Listings";
import { ListingCard } from "./ListingCard";
import { Spacer } from "src/components/base";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { exclusiveListingsResponsive } from "src/utils";
import { SectionHeader } from "../SectionHeader";

export const ListingSection = () => {
    const bp = useBreakpoint();
    const history = useHistory();
    const [cards, setCards] = useState<RoomData[] | null>();

    const deferredFetch = async () => {
        try {
            const exclusiveData = await fetchListings({
                filters: `brokerage=MANORLEAD GROUP INC., BROKERAGE&isExclusive=true&count=10&leaseOrSale=Sale`,
            });
            const dataListings1 = await fetchListings({
                filters: `brokerage=MANORLEAD GROUP INC., BROKERAGE&isExclusive=false&count=20&leaseOrSale=Sale`,
            });
            const dataListings2 = await fetchListings({
                filters: `brokerage=MANORLEAD GROUP INC.&isExclusive=false&count=20&leaseOrSale=Sale`,
            });
            setCards(
                exclusiveData.residentialListings.concat(
                    dataListings2.residentialListings,
                    dataListings1.residentialListings,
                ),
            );
        } catch (err) {
            console.error("ERROR: ", err);
        }
    };

    useEffect(() => {
        deferredFetch();
    }, []);

    const handleViewMore = () => {
        history.push({
            pathname: `/residential`,
        });
    };

    const handleClick = (id: string) => {
        history.push({
            pathname: `/listing/${id}`,
        });
    };

    return (
        <>
            <HomePageContentWrapper>
                <Line />
                <Spacer height={16} />
                <SectionHeader
                    title={intl.get("homePage.exclusive.title")}
                    subtitle={intl.get("homePage.exclusive.subTitle")}
                    buttonText={intl.get("homePage.exclusive.viewMore")}
                    onButtonClick={handleViewMore}
                    bp={bp}
                />
                <Spacer height={16} />
                {cards && (
                    <StyledDiv>
                        <Carousel
                            swipeable={true}
                            draggable={false}
                            arrows={true}
                            showDots={true}
                            renderDotsOutside
                            responsive={exclusiveListingsResponsive}
                            autoPlaySpeed={9000}
                            partialVisible={true}
                            autoPlay={false}
                            renderButtonGroupOutside={true}
                            keyBoardControl={true}
                            transitionDuration={500}
                            ssr={false}
                        >
                            {cards.map((r) => (
                                <ListingCardContainer key={r.id}>
                                    <ListingCard listing={r} route={handleClick} />
                                </ListingCardContainer>
                            ))}
                        </Carousel>
                    </StyledDiv>
                )}
            </HomePageContentWrapper>
        </>
    );
};

const StyledDiv = styled.div`
    max-width: 100%;
    position: relative;

    .react-multi-carousel-dot-list {
        position: static;
        margin-top: 16px;
        gap: 6px;
    }

    .react-multi-carousel-dot button {
        border: none;
        width: 7px;
        height: 7px;
        background: rgba(0, 0, 0, 0.16);
    }

    .react-multi-carousel-dot--active button {
        background: #1d1d1f;
    }
`;

const ListingCardContainer = styled.div`
    margin: 4px 16px 0 0;
`;
